class FulfilmentSelectorDialogContentController {
    constructor(fulfilmentSelectorService) {
        this.fulfilmentSelectorService = fulfilmentSelectorService;
    }

    $onInit() {
        this.dialogCtrl.show();
    }
}

FulfilmentSelectorDialogContentController.$inject = ['FulfilmentSelectorService'];

const fulfilmentSelectorDialogContentComponentDefinition = {
    require: { dialogCtrl: '^dialog' },
    controller: FulfilmentSelectorDialogContentController,
    template: require('./fulfilment-selector-dialog-content.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorDialogContentController,
    fulfilmentSelectorDialogContentComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-dialog-content.component.js